import api from '@/services/api';
import { PaginatedResponse } from '@/types/common';
import {
  Creator,
  CreateCreatorRequest,
  UpdateCreatorRequest,
  GetCreatorsParams,
} from '@/types/creators';

export const creatorsService = {
  async getAll(params: GetCreatorsParams = {}): Promise<PaginatedResponse<Creator>> {
    const queryParams = new URLSearchParams();

    const offset = params.offset ?? 0;
    const limit = params.limit ?? 100;
    queryParams.append('offset', String(offset));
    queryParams.append('limit', String(limit));

    Object.entries(params).forEach(([key, value]) => {
      if (key === 'offset' || key === 'limit') return;
      if (value !== undefined && value !== '') {
        queryParams.append(key, value.toString());
      }
    });

    const url = `/creators?${queryParams.toString()}`;
    const response = await api.get<PaginatedResponse<Creator>>(url);
    return response.data;
  },

  async getById(id: string): Promise<Creator> {
    const response = await api.get<Creator>(`/creators/${id}`);
    return response.data;
  },

  async create(creatorData: CreateCreatorRequest): Promise<Creator> {
    const response = await api.post<Creator>('/creators', creatorData);
    return response.data;
  },

  async update(id: string, creatorData: UpdateCreatorRequest): Promise<Creator> {
    const response = await api.patch<Creator>(`/creators/${id}`, creatorData);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/creators/${id}`);
  },

  async toggleStatus(id: string): Promise<Creator> {
    const creator = await this.getById(id);
    return this.update(id, { is_active: !creator.is_active });
  },

  async upload(file: File): Promise<{ message: string; imported: number }> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post<{ message: string; imported: number }>('/creators/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};
